<template>
  <div >
    <div class="bande is-hidden-touch" style="height:50%;">
      <!--colonnes-->
      <div class="columns">
        <!--colonne 1-->
        <div class="column">
           <!--colonne 1 : Titre-->
            <p class="Titre  is-size-4-desktop " >Adresse</p>
            <!--colonne 1 : Reponse -->
            <p class="Reponse is-size-5-desktop " style=" margin-left:10%;">15 Rue Lamoricière,  <br>44100 Nantes</p>
        </div>
        <div class="column" >
           <!--colonne 2 : Titre-->
            <p class="Titre  is-size-4-desktop ">Téléphone</p>
            <!--colonne 2 : Reponse -->
            <p class="Reponse  is-size-5-desktop " style=" margin-left:10%;">09 72 32 43 57</p>
        </div>
        <div class="column" >
          <!--colonne 3 : Titre-->
            <p class="Titre is-size-4-desktop ">E-mail</p>
            <!--colonne 3 : Reponse -->
             <p class="Reponse is-size-5-desktop "><span  v-on:click="scrollFix('#5')"><router-link class="Reponse"   style=" margin-left:10%;" to="/contact"> contact@fobware.com </router-link></span></p>
        </div>
    </div>
  </div>
 <div class="bande is-hidden-desktop" style="height:10%;">
      <!--colonnes-->
      
            <p class="Titre  is-size-7" style="padding-top:3%;" >Adresse</p>
            <!--colonne 1 : Reponse -->
            <p class="Reponse is-size-7" style=" margin-left:10%;">15 Rue Lamoricière,  <br>44100 Nantes</p>
       
           <!--colonne 2 : Titre-->
            <p class="Titre  is-size-7">Téléphone</p>
            <!--colonne 2 : Reponse -->
            <p class="Reponse  is-size-7" style=" margin-left:10%;">09 72 32 43 57</p>
        
          <!--colonne 3 : Titre-->
            <p class="Titre is-size-7 ">E-mail</p>
            <!--colonne 3 : Reponse -->
             <p class="Reponse is-size-7"  style="padding-bottom:3%;"><span  v-on:click="scrollFix('#5')"><router-link class="Reponse"   style=" margin-left:10%;" to="/contact"> contact@fobware.com </router-link></span></p>
     
  </div>
  
  <!--Liens mentions légales -->
   <a ><span  v-on:click="scrollFix('#6')"><router-link to="/notice"> <p class="MentionsLegale">Mentions légales © 2021 par FOBware SI </p> </router-link></span></a>
  </div>
</template>

<script>
export default {
  name: "Foot",
  methods: {
    scrollFix: function(hashbang)
    {
      location.hash = hashbang;
    }
  }
};
</script>
<style scoped>

@import url('https://fonts.googleapis.com/css2?family=Spartan:wght@300&display=swap');

.columns{
  margin-right:15%;
  margin-left:18%;
}
.bande{
     background-color: #482A5C;
  
     width:100%;
     position: relative;
}


.Titre{
  margin-top:4%;
  align-content: space-between;
  font-weight: bold;
  color:white;
  text-align: left;
  margin-left:10%;
  font-family: 'Spartan', sans-serif;
  font-weight: bold;
}

.Reponse{
  margin-bottom:2%;
  margin-top:4%;
  color:white;
  text-align: left;
  font-family: 'Spartan', sans-serif;
}

.MentionsLegale{
  margin-top:5%;
  margin-bottom:3%;
  text-decoration: none;
}
a{
  text-decoration: none;
  color:black;
   
}
</style>